import Bugsnag from '@bugsnag/js';

export function reportError(error) {
    if (! Bugsnag.isStarted()) {
        console.error(error);
        return;
    }

    Bugsnag.notify(error);
}

